import { axios } from '@Root/API'

export const postContinuingStudents = payload => {
  return axios.post(`student-engagement/rollover-continuing`, payload)
}
